import { AuthProvider } from './hooks/useAuth';
import Home from './pages/Home';
import './styles/main.css';

export default function App() {
  return (
      <AuthProvider>
        <Home />
      </AuthProvider>
  );
}
